export const customFieldIndicator = 'CustomField---';
export const customFieldMultipleValuesIndicator = 'CustomFieldMultipleValuesFilters---';
export const appliedFilterIndicator = '---Applied';
export const getMinMaxIndicator = '---GetMinMax';
export const treeParentChildSeparator = '-@-';
export const customerFieldIndicator = 'CustomerField---';
export const invoiceFieldIndicator = 'InvoiceField---';
export const creditFieldIndicator = 'CreditField---';
export const ticketFieldIndicator = 'TicketField---';
export const taskFieldIndicator = 'TaskField---';
export const communicationDeliveryFieldIndicator = 'CommunicationDeliveryField---';
export const paymentFieldIndicator = 'PaymentField---';